import { render, staticRenderFns } from "./TenantSystemPrefsForm.vue?vue&type=template&id=2b9fb68b&scoped=true"
import script from "./TenantSystemPrefsForm.vue?vue&type=script&lang=ts"
export * from "./TenantSystemPrefsForm.vue?vue&type=script&lang=ts"
import style0 from "./TenantSystemPrefsForm.vue?vue&type=style&index=0&id=2b9fb68b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9fb68b",
  null
  
)

export default component.exports